<template>
  <TemplateRegistro :titulo="titulo" :texto="texto" @intro="submit()">
    <label for="uname"><strong>Número de verificación (PIN)</strong></label>
    <input
      id="uname"
      v-model.trim="pin"
      type="tel"
      placeholder="Introduzca el PIN"
      required
      @keydown="clearErrors()"
    />

    <PanelMensajes :mensaje="error" clase="error" />

    <button type="submit" class="pure-button ripple" @click.prevent="submit()">
      <strong>Continuar</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
export default {
  data() {
    return {
      pin: "",
      error: "",
      titulo: "Verificación",
      texto:
        "Por favor, escribe el código PIN que te hemos enviado por SMS al teléfono " +
        this.$store.state.registroInfo.telefono
    };
  },

  methods: {
    submit: async function() {
      let result = await this.$store.dispatch("verificarPin", {
        pin: this.pin
      });

      if (result.codigo != 0) {
        this.error = result.mensaje;
        return;
      }

      this.$router.replace({ name: "registroClaves" });
    },

    clearErrors() {
      this.error = "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
